/**
 * Created by razial on 03.02.2026.
 */

const CompositeView = function (composite, unitView) {
    this.composite = composite;
    this.unitView = unitView;
    this.partsVisible = true;
};

CompositeView.prototype.createParts = function () {
    if (this.parts) {
        return;
    }

    if ((this.unitView.sprite instanceof LazyAsset) && !this.unitView.sprite.isLoaded()) {
        return;
    }

    this.parts = [];

    const mapView = Map2d.currentMap.getMapView();

    const json = UnitView.UnitIconJson(this.composite.unit);

    const animation = this.unitView.getAnimation();

    animation && animation.listAnimations().forEach((animationName) => {
        const offset = this.composite.offsetFromAnimation(animationName);
        if (!offset) {
            return;
        }

        const cell = cc.p(this.composite.unit.x + offset.x, this.composite.unit.y + offset.y);

        if (offset.unitView) {
            if (this.unitView.parent && this.unitView.parent.cell && !cc.pointEqualToPoint(this.unitView.parent.cell, cell)) {
                mapView.addTile(Map2d.LAYER_UNITS, cell.x, cell.y, this.unitView);
            }
            return;
        }

        const part = new cleverapps.Spine(json);
        part.setAnimation(0, animationName, true);

        if (cleverapps.config.debugMode) {
            part._debugExclude = true;
        }

        if (mapView.containsView(this.unitView)) {
            mapView.addTile(Map2d.LAYER_UNITS, cell.x, cell.y, part);
        } else {
            this.unitView.addChild(part);
        }

        part.setAnchorPoint(this.unitView.sprite.anchorX, this.unitView.sprite.anchorY);
        part.setPosition(part.parent.convertToNodeSpace(this.unitView.sprite.parent.convertToWorldSpace(this.unitView.sprite)));

        if (offset.zOrder) {
            part.setLocalZOrder(offset.zOrder);
        }

        this.parts.push(part);
    });

    if (!this.partsVisible) {
        this.setPartsVisibility(false);
    }

    this.updatePartsOutline();
};

CompositeView.prototype.removeParts = function () {
    if (!this.parts) {
        return;
    }

    this.parts.forEach((part) => {
        part.removeFromParent();
    });
    this.parts = undefined;

    this.updatePartsOutline();
};

CompositeView.prototype.setPartsVisibility = function (visible) {
    this.partsVisible = visible;

    if (!this.parts) {
        return;
    }

    this.parts.forEach((part) => {
        part.stopAllActions();
        part.setVisible(visible);
    });
};

CompositeView.prototype.showPartsUp = function () {
    this.partsVisible = true;

    if (!this.parts) {
        return;
    }

    this.parts.forEach((part) => {
        part.stopAllActions();
        part.runAction(StandartAnimations.showUp(part));
    });
};

CompositeView.prototype.updatePartsOutline = function () {
    const outline = this.unitView.sprite && this.unitView.sprite.outlineSprite;
    if (!outline) {
        return;
    }

    outline.setParts(this.parts || []);
};